// Sticky quick-links bar: starts in flow, pins on scroll, releases at the last target.
(() => {
  const norm = (s) => (/^[#.[]/.test(s) ? s : `#${s}`);

  const build = (nav) => {
    const mount = nav.closest('[data-pi-quick-nav-mount]') ?? nav.parentElement;
    const list = nav.querySelector('[data-pi-nav-list]');
    if (!mount || !list) return;
    nav._cleanup?.();

    const targets = [...document.querySelectorAll('[data-pi-nav-title][id]')].filter(
      (el) => el.dataset.piNavTitle.trim()
    );

    const { piExtraTarget: sel, piExtraLabel: label } = nav.dataset;
    if (sel?.trim() && label?.trim()) {
      let el;
      try {
        el = document.querySelector(norm(sel.trim()));
      } catch { }

      if (el && !targets.includes(el)) {
        el.id ||= 'pi-nav-extra';
        el.dataset.piNavTitle = label.trim();
        targets.push(el);
      }
    }

    if (!targets.length) {
      nav.hidden = true;
      return;
    }

    list.replaceChildren(
      ...targets.map((el) => {
        const a = document.createElement('a');
        a.className = 'pi-quick-nav__link';
        a.href = `#${el.id}`;
        a.textContent = el.dataset.piNavTitle.trim();
        const li = document.createElement('li');
        li.className = 'pi-quick-nav__item';
        li.append(a);
        return li;
      })
    );
    nav.hidden = false;

    const links = [...list.querySelectorAll('.pi-quick-nav__link')];
    const offset = parseInt(nav.dataset.piOffset, 10) || 0;
    const gap = 12; // space below the bar; also the active-detection line
    const last = targets.at(-1);

    const setScrollMargin = () => {
      const m = `${offset + nav.offsetHeight + gap}px`;
      targets.forEach((t) => (t.style.scrollMarginTop = m));
      document.documentElement.style.setProperty('--pi-scroll-margin', m);
    };

    let ticking = false;
    const update = () => {
      ticking = false;

      const h = nav.offsetHeight;
      const top = mount.getBoundingClientRect().top;
      const bottom = last.getBoundingClientRect().bottom;
      const line = offset + h + gap + 1;
      let active = '';
      for (const t of targets) if (t.getBoundingClientRect().top <= line) active = t.id;

      const pin = top <= offset && bottom > offset;
      mount.style.height = pin ? `${h}px` : '';
      nav.classList.toggle('is-pinned', pin);
      nav.style.top = pin ? `${Math.min(offset, bottom - h)}px` : ''; // clamp = sticky release
      links.forEach((a) => a.classList.toggle('is-active', a.hash === `#${active}`));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    const onResize = () => {
      setScrollMargin();
      update();
    };

    setScrollMargin();
    update();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onResize, { passive: true });
    nav._cleanup = () => {
      removeEventListener('scroll', onScroll);
      removeEventListener('resize', onResize);
    };
  };

  const init = () => document.querySelectorAll('[data-pi-quick-nav]').forEach(build);
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', init) : init();
  addEventListener('shopify:section:load', init);
})();
